import React, { useEffect, useState } from 'react'
import { TextMediumBase, TextMediumSM } from '../../../../../Components/Text/MediumText'
import Breadcrumb from '../../../../../Components/Utils/Breadcrumb'
import { BackButton, CancelButton, CreateButton, SubmitButton } from '../../../../../Components/Utils/Buttons'
import axiosInstance from '../../../../../Services/axiosCommon'
import { useFormik } from 'formik'
import UseEditData from '../../../../../Components/Hooks/useEditData'
import { ToggleRight } from 'lucide-react'
import { HeadingWithIcon } from '../../../../../Components/Utils/Settingheading'
import { Link } from 'react-router-dom'
import ViewIcon from '../../../../../Components/Icons/ViewIcon'
import FormsApproveLayout from '../Layout'
import { useToast } from '../../../../../Components/Others/ToastServices'

function FormsApprove() {
  const [data, setData] = useState([])
  const [initialData, setInitialData] = useState([])
  const { Oncancel, editData, isLoading } = UseEditData()

  



  // const initialData = [
  //   { id: 1, 
  //     label: "Fire Fighting System",
  //     enabled: true,
  //     formList:[] 
  //   },
  //   { 
  //     id: 2, 
  //     label: "Fire Alarm System", 
  //     enabled: false, 
  //     formList:[
  //     ] },
  // ];

  // const [data, setData] = useState(initialData);
  // const [isLoading, setIsLoading] = useState(false);



  // const formik = useFormik({
  //   initialValues: {
  //     forms: data,
  //   },
  //   onSubmit: (values) => {
  //     setIsLoading(true);
  //     console.log("Submitted values:", data);
  //     // Simulate submission
  //     setTimeout(() => {
  //       setIsLoading(false);
  //       alert("Form submitted!");
  //     }, 1000);
  //   },
  // });
    const toast = useToast();
  

  const handleToggleChange = (id) => {
    const updated = data.find((item) => item.id === id);
    let value = {
      isEnabled: !updated.enabled,
    };
    axiosInstance
      .put(`/survey-category/edit-status/${id}`, value)
      .then((res) => {
        if (res.data?.status === true) {
          getData();
          toast.open({
            type: "success",
            message: "Success",
            description: res.data?.msg || "Created Successfully.",
          });
        } else if (res.data?.status === false && res.data?.error) {
          toast.open({
            type: "error",
            message: "Error",
            description: res.data.error || "Network error.",
          });
        } else {
          toast.open({
            type: "warning",
            message: "Warning",
            description: res.data?.msg || "Warning.",
          });
        }
      })
      .catch((err) => {
        toast.open({
          type: "error",
          message: "Error",
          description: "Network error.",
        });
      });
  };



function getData() {
    axiosInstance.get(`/survey-category/`)
      .then(res => {
        setData(res?.data?.data)
        setInitialData(JSON.parse(JSON.stringify(res?.data?.data))) // Deep copy for comparison
      })
      .catch(err => {
        console.log(err)
      })
  }

  useEffect(() => {
    getData()
  }, [])

  const formatName = (text) => {
    if (!text) return "-"
    return text
      .split("_")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ")
  }

  return (
    <FormsApproveLayout>
    <div className="w-full h-full mt-0.5  overflow-hidden">
    <div className="w-full bg-white mx-auto p-2 rounded-md">
      <HeadingWithIcon icon={ToggleRight} title="Survey Forms" />
      <form className="space-y-2">
        {/* SCROLLABLE TABLE AREA */}
        <div className="w-full h-[calc(100vh-250px)] overflow-y-auto border rounded-xl shadow-sm bg-white relative">
          <table className="w-full table-fixed min-w-full text-sm border-separate border-spacing-0">
            <thead className="sticky top-0 z-10 bg-gradient-to-r from-red-600 to-red-400 text-white shadow-sm">
              <tr>
                <th className="w-[60%] text-left py-3 px-4 font-semibold">Form</th>
                <th className="w-[20%] text-center py-3 px-4 font-semibold">Enable / Disable</th>
                <th className="w-[20%] text-left py-3 px-4 font-semibold">Action</th>
              </tr>
            </thead>

      <tbody>
        {data.map((value, index) => (
          <React.Fragment key={index}>
          <tr
            key={value.id}
            className="even:bg-slate-50 odd:bg-white hover:bg-slate-100 transition-all duration-200"
          >
            <td className="py-3 px-4 text-left font-medium text-gray-700">{value.category}</td>

            <td className="py-3 px-4 text-center">
              <label className="inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={value.enabled}
                  onChange={() => handleToggleChange(value.id)}
                  className="sr-only peer"
                />
                <div
                  className={`relative w-12 h-6 rounded-full transition-all duration-300 peer ${
                    value.enabled ? "bg-baseColor-primary" : "bg-gray-300"
                  }`}
                >
                  <div
                    className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white border border-gray-300 rounded-full transition-all duration-300 ${
                      value.enabled ? "translate-x-6" : ""
                    }`}
                  ></div>
                </div>
              </label>
            </td>

            <td className="py-3 px-4 text-left">
              <Link
                to={`/settings/formsApprove/survey/viewSurvey/${value?.id}`}
                state={{ data: data }}
                className="inline-flex items-center gap-1 text-teal-700 hover:text-teal-900 transition"
              >
                <ViewIcon color="#048178" />
                <span className="hidden md:inline">View</span>
              </Link>
            </td>
          </tr>
          {
            value.formList && value.formList.length > 0 && value.formList.map((form, formIndex) => (
              <tr
                key={`${value.id}-${form.id}`}
                className="even:bg-slate-50 odd:bg-white hover:bg-slate-100 transition-all duration-200"
              >
                <td className="py-3 px-8 pl-12 text-left text-gray-600">
                  {formatName(form.name)}
                </td>
                <td className="py-3 px-4 text-center">
                  <label className="inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={form.enabled}
                      onChange={() => {
                        const updatedForms = data.map(item =>
                          item.id === value.id
                            ? {
                                ...item,
                                formList: item.formList.map(f =>
                                  f.id === form.id ? { ...f, enabled: !f.enabled } : f
                                ),
                              }
                            : item
                        );
                        setData(updatedForms);
                      }}
                      className="sr-only peer"
                    />
                    <div
                      className={`relative w-12 h-6 rounded-full transition-all duration-300 peer ${
                        form.enabled ? "bg-baseColor-primary" : "bg-gray-300"
                      }`}
                    >
                      <div
                        className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white border border-gray-300 rounded-full transition-all duration-300 ${
                          form.enabled ? "translate-x-6" : ""
                        }`}
                      ></div>
                    </div>
                  </label>
                </td>
                <td className="py-3 px-4 text-left">
                  <Link
                    to={`/settings/formsApprove/survey/viewFormSur/${form?.id}`}
                    state={{ data: data }}
                    className="inline-flex items-center gap-1 text-teal-700 hover:text-teal-900 transition"
                  >
                    <ViewIcon color="#048178" />
                    <span className="hidden md:inline">View</span>
                  </Link>
                </td>
              </tr>
            ))
          }
          </React.Fragment>
        ))}
      </tbody>
    </table>
  </div>

  {/* <div className="flex justify-end gap-4 mt-6">
    <CancelButton
      handleClick={() => {
        setData(initialData);
      }}
    />
    <SubmitButton
      disabled={isLoading || JSON.stringify(data) === JSON.stringify(initialData)}
    />
  </div> */}
</form>

      </div>
      
    </div>
    </FormsApproveLayout>
  )
}

export default FormsApprove